import React from "react";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import RichHtml from "@/components/RichHtml";
import { useFetch } from "@/lib/useData";
import { openCookiePreferences } from "@/components/CookieConsent";

export default function CookiePolicy() {
  const { data } = useFetch("/pages/cookie-policy");
  const body = data?.body_html || "";
  const lastUpdated = data?.updated_at?.slice(0, 10) || "";
  return (
    <>
      <SEO title="Cookie Policy | Infinity Medical Group" description="How Infinity Medical Group uses cookies, the categories we set, and how to manage your choices." />
      <Breadcrumbs />
      <section className="bg-white pt-4 pb-12">
        <div className="container max-w-3xl">
          <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-teal">— Privacy</p>
          <h1 className="mt-3 font-display font-bold text-4xl md:text-5xl text-navy-800 tracking-tight">Cookie Policy</h1>
          {lastUpdated && <p className="mt-3 text-sm text-navy-500">Last updated {lastUpdated}</p>}
          <button
            onClick={openCookiePreferences}
            data-testid="open-cookie-preferences"
            className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-navy text-white text-sm font-semibold hover:bg-teal transition-colors"
          >
            Manage cookie preferences
          </button>
        </div>
      </section>
      <section className="bg-soft-gray py-14">
        <div className="container max-w-3xl">
          {body ? (
            <RichHtml html={body} />
          ) : (
            <p className="text-navy-700">Cookie Policy is being prepared and will be published shortly.</p>
          )}
        </div>
      </section>
    </>
  );
}
